import MuiLoadingButton from '@mui/lab/LoadingButton'
import React from 'react'

const LoadingButton = (props) => {
  return <MuiLoadingButton {...props} />
}

export { LoadingButton }
